import { assign } from '@xstate/immer';
import { findOptionIndex, findOption } from './actions.js';

var actions = {
    makeActiveSelected: assign(function (ctx) {
        var activeOption = ctx.activeOption;
        if (activeOption) {
            ctx.options[findOptionIndex(ctx, activeOption.value)].selected = true;
        }
    }),
    toggleActiveSelected: assign(function (ctx) {
        var active = ctx.activeOption;
        if (!active)
            return;
        var option = findOption(ctx, active.value);
        if (option) {
            option.selected = !option.selected;
        }
    }),
};

export { actions };
//# sourceMappingURL=actionsMultiple.js.map
